export const menu = [
  {
    id: "Master",
    icon: "bx bx-map-alt",
    label: "Master Settings",
    to: "/",
    subs: [
      {
        id: "age-group",
        icon: "bx bx-bar-chart",
        label: "Age Groups",
        to: "/age-group",
        badge: "no",
      },
      {
        id: "Task",
        icon: "bx bx-bar-chart",
        label: "Tasks",
        to: "/task",
        badge: "no",
      },
      {
        id: "assessment",
        icon: "bx bx-bar-chart",
        label: "Self Assessments",
        to: "/assessment",
        badge: "no",
      },
      {
        id: "Quiz",
        icon: "bx bx-bar-chart",
        label: "Quiz",
        to: "/quiz",
        badge: "no",
      },

      {
        id: "cmsContent",
        icon: "bx bx-bar-chart",
        label: "CMS Content",
        to: "/cms-content",
        badge: "no",
      },
      {
        id: "Users",
        icon: "bx bx-bar-chart",
        label: "Users",
        to: "/users",
        badge: "no",
      },

      {
        id: "kids",
        icon: "bx bx-bar-chart",
        label: "Kids",
        to: "/kids",
        badge: "no",
      },
      {
        id: "schools",
        icon: "bx bx-bar-chart",
        label: "Schools",
        to: "/schools-list",
        badge: "no",
      },
      // {
      //   id: "Merchant",
      //   icon: "bx bx-bar-chart",
      //   label: "Merchant",
      //   to: "/merchant",
      //   badge: "no",
      // },

      // {
      //   id: "homepageimage",
      //   icon: "bx bx-bar-chart",
      //   label: "HomePage Image",
      //   to: "/homepageimage",
      //   badge: "no",
      // },
    ],
  },
]

export const allMenu = []
